import tw, { css } from 'twin.macro'
import { useForm, useFormContext, Controller } from 'react-hook-form'
import {
  validationMessageWithDefault,
  validationRules,
} from '../../../utils/validationErrorMessages'
import { forwardRef, useEffect, useMemo, useState } from 'react'
import pickBy from 'lodash/pickBy'
import isFunction from 'lodash/isFunction'
import mapValues from 'lodash/mapValues'
import get from 'lodash/get'
import BasicCheckbox from '../Checkbox/HorseProfileCheckBox/BasicCheckbox'
import AdvancedCheckbox from '../Checkbox/HorseProfileCheckBox/AdvancedCheckbox'
import './style.css'
import RadioSelect from '../Checkbox/HorseProfileCheckBox/AdvanceRadioSelect'

const uid = function () {
  return Date.now().toString(36) + Math.random().toString(36).substr(2)
}

export const FormInput = forwardRef(
  (
    {
      autoFocus,
      reactSelectClassName,
      hidden,
      disabled,
      id,
      isDisabled,
      onInput: onInputR = () => { },
      type = 'text',
      options = [],
      step,
      isClearable = false,
      selectedValues,
      onChange = () => { },
      onClick = () => { },
      name: nameR = null,
      register: registern = () => { },
      label,
      isOptionDisabled,
      validations = {},
      required,
      placeholder,
      maxLength,
      props,
      className,
      height,
      closeMenuOnSelect,
      isMulti,
      methods: methodsR = null,
      validateOnChange = true,
      icon,
      readOnly = false,
      showEyeIcon = false,
      showPassword = false,
      onToggleShowPassword,
      navigate,
      styles,
    },
    ref,
  ) => {
    const methods = useFormContext()
    const [name] = useState(nameR || uid())
    const [errorsr, setErrorsR] = useState({})
    const customForm = useForm()
    const validationForm = useMemo(
      () => methods || customForm,
      [methods, customForm],
    )

    const customValidations = useMemo(
      () =>
        mapValues(
          pickBy(validations, (v, k) => !!validationRules[k]),
          (v, k) => (isFunction(v) ? v : validationRules[k].apply(this, [v])),
        ),
      [validations],
    )

    const onInput = (function () {
      var fn = onInputR
      return function () {
        const $this = this
        const $arguments = arguments
        return (function () {
          const out = fn.apply($this, $arguments)

          if (validateOnChange) {
            setTimeout(() => {
              validationForm?.trigger(name)
            }, 1)
          }

          return out
        })()
      }
    })()

    useEffect(() => {
      const fn = async () => {
        setTimeout(() => {
          setErrorsR({ ...validationForm?.formState.errors })
        }, 1)
      }

      fn()
    }, [validationForm?.formState])

    const {
      register,
      unregister,
      formState: { isDirty, errors },
      setFocus,
    } = methodsR || methods || customForm

    validations.required =
      typeof required !== 'undefined' && required !== false
        ? true
        : validations.required

    useEffect(() => {
      if (autoFocus) {
        setFocus(name)
      }

      return () => {
        unregister(name)
      }
    }, [name])

    return (
      <>
        <div
          className={`form-input ${className}`}
          tw="flex flex-col"
          css={[hidden && tw`hidden`]}
        >
          {label && (
            <label
              tw="mb-[8px] flex"
              css={[
                validations.required && tw`after:text-black after:text-[12px]`,
              ]}
              htmlFor={name}
            >
              {icon && (
                <div tw="flex items-center ">
                  <img tw="mr-2" src={icon} />
                  {label}
                </div>
              )}
              {!icon && label}
            </label>
          )}
          {type === 'select' ? (
            <Controller
              name={name}
              control={validationForm?.control}
              defaultValue={[]}
              render={({ field }) => (
                <BasicCheckbox
                  field={field}
                  {...register(name, {
                    ...validations,
                    validate: mapValues(customValidations, fn =>
                      fn.bind({
                        form: methods,
                        name: name,
                        label: label,
                      }),
                    ),
                  })}
                  options={options}
                  reactSelectClassName={
                    reactSelectClassName && reactSelectClassName
                  }
                  selectedValues={selectedValues && selectedValues}
                  onChange={onChange}
                  isDisabled={isDisabled}
                  height={height}
                  isMulti={isMulti}
                  closeMenuOnSelect={closeMenuOnSelect}
                  placeholder={placeholder}
                  label={label}
                  className={`${className} appearance-none rounded-full !shadow-none focus:outline-none cursor-pointer`}
                />
              )}
            />
          ) : type === 'single-select' ? (
            <Controller
              name={name}
              control={validationForm?.control}
              render={({ field }) => (
                <RadioSelect
                  {...field}
                  {...register(name, {
                    ...validations,
                    validate: mapValues(customValidations, fn =>
                      fn.bind({
                        form: methods,
                        name: name,
                        label: label,
                      }),
                    ),
                  })}
                  options={options}
                  reactSelectClassName={
                    reactSelectClassName && reactSelectClassName
                  }
                  selectedValue={field.value || (selectedValues && selectedValues)}
                  onChange={option => {
                    field.onChange(option)
                    onChange(option)
                  }}
                  height={height}
                  id={id}
                  isDisabled={isDisabled}
                  closeMenuOnSelect={closeMenuOnSelect}
                  isMulti={isMulti}
                  placeholder={placeholder}
                  label={label}
                  navigate={navigate}
                  styles={styles}
                  className={`${className} appearance-none rounded-full !shadow-none focus:outline-none cursor-pointer`}
                />
              )}
            />
          ) : type === 'select2' ? (
            <Controller
              name={name}
              control={validationForm?.control}
              render={({ field }) => (
                <AdvancedCheckbox
                  {...field}
                  {...register(name, {
                    ...validations,
                    validate: mapValues(customValidations, fn =>
                      fn.bind({
                        form: methods,
                        name: name,
                        label: label,
                      }),
                    ),
                  })}
                  options={options}
                  reactSelectClassName={
                    reactSelectClassName && reactSelectClassName
                  }
                  selectedValues={field.value || (selectedValues && selectedValues)}
                  onChange={option => {
                    field.onChange(option)
                    onChange(option)
                  }}
                  height={height}
                  isDisabled={isDisabled}
                  isOptionDisabled={isOptionDisabled}
                  closeMenuOnSelect={closeMenuOnSelect}
                  isMulti={isMulti}
                  placeholder={placeholder}
                  label={label}
                  isClearable={isClearable}
                  className={`${className} appearance-none rounded-full !shadow-none focus:outline-none cursor-pointer`}
                />
              )}
            />
          ) : (
            <input
              {...register(name, {
                ...validations,
                onChange,
                validate: isFunction(validations.validate)
                  ? validations.validate
                  : mapValues(customValidations, fn =>
                    fn.bind({
                      form: methods,
                      name: name,
                      label: label,
                    }),
                  ),
              })}
              step={step}
              autoComplete={'off'}
              aria-autocomplete={'none'}
              readOnly={disabled}
              className={`
                  p-[16px] rounded-[8px] border
                  ${disabled
                  ? `
                    border-gray-300 bg-gray-100 text-gray-500
                    cursor-not-allowed
                    focus:outline-none focus:ring-0
                    pointer-events-none
                  `
                  : `
                    border-[#999] hover:border-[#666] focus:border-blue-500
                    focus:ring-1 focus:ring-blue-500
                  `
                }`}
              onInput={onInput}
              onClick={onClick}
              maxLength={maxLength}
              name={name}
              type={type}
              placeholder={placeholder}
              style={{ border: '1px solid #999' }}
            />
          )}
          {(() => {
            // safely grab nested error object by full name path
            const errorObj = get(validationForm.formState.errors, name)
            if (!errorObj) return null
            return (
              <span css={[formInputErrors]} className="form-input__error">
                {validationMessageWithDefault(
                  errorObj,
                  label.toLowerCase(),
                  (label ?? name).toLowerCase(),
                  null,
                  validations[errorObj.type],
                )}
              </span>
            )
          })()}
        </div>
      </>
    )
  },
)

const formInputErrors = css`
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  color: var(--color-primary-danger);
  white-space: nowrap;
  ${tw`mt-[8px]`}
`

export default FormInput
